import React from 'react';

import {PushNotificationRemoveAttribute} from 'src/components/remove-attribute/push-notification-remove-attribute';
import {AttributeDetailInfo} from 'src/openapi/models/AttributeDetailInfo';

import {Icons, Sizes} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import {usePushNotification} from '@pb/kit-component-push-notification';

import {removeAttribute} from './remove-attribute.module.styl';

type Props = {
    attributeDetailInfo: AttributeDetailInfo,
};

export const RemoveAttribute = ({attributeDetailInfo}: Props) => {
    const {onCreateNote, onCloseNote} = usePushNotification();

    const onRemove = () => {
        if (!attributeDetailInfo.id) {
            return;
        }
        onCreateNote({
            id: `${attributeDetailInfo.id}`,
            body: () => (
                <PushNotificationRemoveAttribute
                    {...{
                        id: attributeDetailInfo.id || 0,
                        name: attributeDetailInfo.name,
                        eventId: attributeDetailInfo.eventId ?? 0,
                        onClose: onCloseNote,
                    }}
                />
            ),
            buttonProps: {icon: Icons.CLOSE},
            autoHideTimeout: 10000,
        });
    };

    return (
        <BasicIconButton
            className={removeAttribute}
            iconProps={{type: Icons.TRASH_LIGHT, size: Sizes.Size_14}}
            onClick={onRemove}
        />
    );
};
